import { useQuery } from '@tanstack/react-query'
import { ApiClient } from '../api'

// All-events service-timetable report — one batched request (replaces the
// per-event fan-out that stalled the printed report).
export function useServiceTimetableReport() {
  return useQuery({
    queryKey: ['reports', 'service-timetable'],
    queryFn: () => ApiClient.reportsServiceTimetable(),
    staleTime: 60_000
  })
}
